import React, { FC } from 'react'
import s from './KuperBannerSecond.module.sass'
import { Title } from '@shared/ui/Typography/Title'
import { useCurrentSize } from '@shared/lib/helpers/classes'
import { AdvertBadge } from '@shared/ui/Feedback/AdvertBadge'
import AdvDetailed from '@features/Common/AdvDetailed/AdvDetailed'
import IconKuper from '@icons/kuper/icon-kuper.svg'
import TitleKuper from '@icons/kuper/title-kuper.svg'
import TestPreview from '@images/rest-card-preview-1.jpg'
import { Button } from '@shared/ui/Actions/Button'
import Link from 'next/link'
import useFeatureFlag from '@shared/lib/hooks/useFeatureFlag'
interface Props {
  sizes: string
  data: {
    restName: string
    link: string
    description: string
    token: string
  }
  className?: string
}

const sizeTitle = { M: 'h2', S: 'h3' }
const sizeAdvertBadge = { M: '62x23', S: '54x19' }

const KuperBannerSecond: FC<Props> = ({ sizes, data, className = '' }) => {
  const [size] = useCurrentSize(sizes)

  const isDevMode = useFeatureFlag('kuper')

  if (!isDevMode) return null

  return (
    <Link href={data.link} className={`${s.banner} ${className}`} data-size={size}>
      <div className={s['preview-wrapper']}>
        <img className={s.preview} src={TestPreview.src} alt={'Превью ресторана'} />
      </div>
      <div className={s.main}>
        <div className={s.advert}>
          <AdvertBadge sizes={sizeAdvertBadge[size]} />
          <AdvDetailed>
            <AdvDetailed.Button className={s['info-button']} />
            <AdvDetailed.Popup description={data.description} token={data.token} />
          </AdvDetailed>
        </div>
        <div className={s['kuper-logo']}>
          <IconKuper className={s['kuper-logo-icon']} />
          <TitleKuper className={s['kuper-logo-title']} />
        </div>
        <div className={s.footer}>
          <Title className={s.title} sizes={sizeTitle[size]}>
            Закажите доставку из {data.restName}
          </Title>
          {size !== 'S' && (
            <Link href={data.link} className={s['button-link']}>
              <Button className={s.button} sizes={'XL'} mode={'black'}>
                Заказать
              </Button>
            </Link>
          )}
        </div>
      </div>
    </Link>
  )
}

export default KuperBannerSecond
